import { SET_PASSCODE_PARAMS, SET_PASSCODE_DONE, SET_PASSCODE_ERROR, SET_PASSCODE_RESET, REMOVE_PASSCODE_PARAMS, REMOVE_PASSCODE_DONE, REMOVE_PASSCODE_ERROR, REMOVE_PASSCODE_RESET } from './actionTypes';
export const setPasscode = (data) => ({
    type: SET_PASSCODE_PARAMS,
    data
});
export const setPasscodeDone = (data) => ({
    type: SET_PASSCODE_DONE,
    data
});
export const setPasscodeError = (data) => ({
    type: SET_PASSCODE_ERROR,
    data
});
export const setPasscodeReset = () => ({
    type: SET_PASSCODE_RESET
});
export const removePasscode = () => ({
    type: REMOVE_PASSCODE_PARAMS
});
export const removePasscodeDone = (data) => ({
    type: REMOVE_PASSCODE_DONE,
    data
});
export const removePasscodeError = (data) => ({
    type: REMOVE_PASSCODE_ERROR,
    data
});
export const removePasscodeReset = () => ({
    type: REMOVE_PASSCODE_RESET
});
//# sourceMappingURL=actionCreators.js.map